import React from "react"
import _ from "lodash"
import styled from "styled-components"
import { InputText_s } from "styles/input-styles"
import automationService from "data/automation"

export const TableSearchHeader_s = styled.div`
  position: fixed;
  right: 2px;
  top: 92px;
  z-index: 3;
`

type ISearchHeader = {
  setSearchFilter: Function
  className?: string
}

const SearchHeader = (props: ISearchHeader) => {
  const debSetSearchFilter = _.debounce(props.setSearchFilter, 618)

  return (
    <TableSearchHeader_s className={props.className}>
      <InputText_s id="search-bar" type="search" onInput={e => {
        automationService.broadcast("SEARCHING", {})
        debSetSearchFilter(e.target["value"])
      }} placeholder="Search" size={36} />
    </TableSearchHeader_s>
  )
}

export default SearchHeader